import { FaqSection } from '@/shared/ui/FaqSection'

import cl from './filter-faq.module.scss'

type FilterFaqProps = {
	items: {
		ANSWER: string
		QUESTION: string
	}[]
	title: string
}

export const FilterFaq = (props: FilterFaqProps) => {
	const { items, title } = props

	const adptedItems = items?.map(({ ANSWER, QUESTION }) => ({ question: QUESTION, answer: ANSWER }))

	if (!adptedItems?.length) return null

	return (
		<section className={cl.section}>
			{title && <h2 className={cl.title}>{title}</h2>}
			<FaqSection items={adptedItems} />
		</section>
	)
}
